module.exports = __webpack_public_path__ + "static/project_mobile-21a2e0e22b4560fcc219ebeeee263cb3.png";